import { routes } from "../../../constants/routes";
export const breadcrumbLink = [
  {
    label: "Campaigns",
    link: "#",
    handleClick: () => {},
  },
  {
    label: "View Campaigns",
    link:routes.CAMPAIGNLIST,
    handleClick: () => {},
  },
];